import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import HomeApp from "./components/home";
import Login from "./components/login";

const Routing = () => {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Navigate to="/login" />} />
        <Route exact path="/index.html" element={<HomeApp />} />
        <Route exact path="/login" element={<Login />} />
        <Route exact path="/login/:appName" element={<Login />} />
      </Routes>
    </Router>
  );
};

export default Routing;
